import i18n from "src/lib/i18n";
import { CATEGORY_TYPES } from "@constants";
import compareVersions, { VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR } from "@cores/version";

export const keywordParam = {
    Collection: "name",
    Asset: "name",
    CustomContent: "name",
    ContentSchema: "name",
    Vocabulary: "name",
    RoleManagement: "name",
    MetadataExports: "name",
    AuditLogs: "ResourceId",
};

export const getSearchParamsCollection = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                {
                    id: "id",
                    subtitle: "ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter ID`),
                },
                {
                    id: "creator",
                    subtitle: "Created by",
                    type: "users",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter the creator`),
                },
                { id: "createdAt", subtitle: "Created", type: "dateRange", essential: false },
                {
                    id: "updater",
                    subtitle: "Updated by",
                    type: "users",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter the person who modified it`),
                },
                { id: "updatedAt", subtitle: "Updated", type: "dateRange", essential: false },
                {
                    id: "tags",
                    subtitle: "Tags",
                    type: "tags",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter after entering`),
                },
            ],
        },
    ];
};

export const getSearchParamsAsset = (version) => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Assets Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "id",
                    subtitle: "Assets ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id:
                        compareVersions(version, VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR) < 0
                            ? "creator"
                            : "owner",
                    subtitle: "Owner",
                    type:
                        compareVersions(version, VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR) < 0
                            ? "text"
                            : "owners",
                    essential: true,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "status",
                    subtitle: "Status",
                    type: "select",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::All status`),
                },
                {
                    id: "mediaType",
                    subtitle: "Media type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All media type`),
                    divider: true,
                },
                {
                    id: "duration",
                    subtitle: "Duration",
                    type: "time",
                    essential: false,
                },
                {
                    id: "type",
                    subtitle: "Type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All types`),
                },
                {
                    id: "categoryIds",
                    subtitle: "Categories",
                    type: "categories",
                    essential: true,
                    placeholder: i18n.t(`common::label::Select category`),
                },
                {
                    id: "contentSchema",
                    subtitle: "Custom Metadata",
                    type: "objectSelect",
                    essential: true,
                    multiple: false,
                    placeholder: i18n.t(`common::label::Select custom metadata`),
                },
                {
                    id: "tags",
                    subtitle: "Tags",
                    type: "tags",
                    essential: true,
                    placeholder: i18n.t(`common::label::Enter after entering`),
                },
                {
                    id: "extensions",
                    subtitle: "Extension",
                    type: "select",
                    multiple: true,
                    essential: true,
                    placeholder: i18n.t(`common::label::All extensions`),
                },
                {
                    id: "jobId",
                    subtitle: "Job ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                    divider: true,
                },
                {
                    id: "ingestType",
                    subtitle: "Ingest type",
                    type: "select",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "fileMeta",
                    subtitle: "File Meta",
                    type: "fileMeta",
                    essential: false,
                },
                {
                    id: "createdAt",
                    subtitle: "Created",
                    type: "assetDateRange",
                    essential: true,
                },
            ],
        },
    ];
};

export const getSearchParamsAssetV2 = (version) => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Assets Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "id",
                    subtitle: "Assets ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id:
                        compareVersions(version, VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR) < 0
                            ? "createdBy"
                            : "owner",
                    subtitle: "Owner",
                    type:
                        compareVersions(version, VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR) < 0
                            ? "users"
                            : "owners",
                    essential: true,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "status",
                    subtitle: "Status",
                    type: "select",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::All status`),
                },
                {
                    id: "mediaType",
                    subtitle: "Media type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All media type`),
                    divider: true,
                },
                {
                    id: "duration",
                    subtitle: "Duration",
                    type: "time",
                    essential: false,
                },
                {
                    id: "type",
                    subtitle: "Type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All types`),
                },
                {
                    id: "categoryIds",
                    subtitle: "Categories",
                    type: "categories",
                    essential: true,
                    placeholder: i18n.t(`common::label::Select category`),
                },
                {
                    id: "contentSchema",
                    subtitle: "Custom Metadata",
                    type: "objectSelect",
                    essential: true,
                    multiple: false,
                    placeholder: i18n.t(`common::label::Select custom metadata`),
                },
                {
                    id: "tags",
                    subtitle: "Tags",
                    type: "tags",
                    essential: true,
                    placeholder: i18n.t(`common::label::Enter after entering`),
                },
                {
                    id: "extensions",
                    subtitle: "Extension",
                    type: "select",
                    multiple: true,
                    essential: true,
                    placeholder: i18n.t(`common::label::All extensions`),
                },
                {
                    id: "jobId",
                    subtitle: "Job ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                    divider: true,
                },
                {
                    id: "ingestType",
                    subtitle: "Ingest type",
                    type: "select",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "fileMeta",
                    subtitle: "File Meta",
                    type: "fileMeta",
                    essential: false,
                },
                {
                    id: "createdAt",
                    subtitle: "Created",
                    type: "assetDateRange",
                    essential: true,
                },
            ],
        },
    ];
};

export const getSearchParamsAllAssets = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Assets Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "id",
                    subtitle: "Assets ID",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "projectIds",
                    subtitle: "Project",
                    type: "objectSelect",
                    multiple: true,
                    essential: true,
                    placeholder: i18n.t(`common::label::Search`),
                },
                {
                    id: "mediaType",
                    subtitle: "Media type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All media type`),
                    divider: true,
                },
                {
                    id: "type",
                    subtitle: "Type",
                    type: "select",
                    multiple: true,
                    essential: false,
                    placeholder: i18n.t(`common::label::All types`),
                },
                {
                    id: "tags",
                    subtitle: "Tags",
                    type: "tags",
                    essential: true,
                    placeholder: i18n.t(`common::label::Enter after entering`),
                },
                {
                    id: "extensions",
                    subtitle: "Extension",
                    type: "select",
                    multiple: true,
                    essential: true,
                    placeholder: i18n.t(`common::label::All extensions`),
                },
                {
                    id: "createdAt",
                    subtitle: "Created",
                    type: "assetDateRange",
                    essential: true,
                },
            ],
        },
    ];
};

export const getSearchParamsCustomContent = (fields, getCustomMetadataOptions) => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    type: "text",
                    subtitle: "Name",
                    essential: true,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                {
                    id: "id",
                    type: "text",
                    subtitle: "ID",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter ID`),
                },
                {
                    id: "description",
                    type: "text",
                    subtitle: "Description",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter description`),
                },
                {
                    id: "status",
                    type: "select",
                    subtitle: "Status",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::All status`),
                },
                {
                    id: "creator",
                    type: "users",
                    subtitle: "Created by",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                { id: "created", type: "date", subtitle: "Created", essential: false },
                {
                    id: "updater",
                    type: "users",
                    subtitle: "Updated by",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                { id: "updated", type: "date", subtitle: "Updated", essential: false },
            ],
        },
        {
            attributions: [
                {
                    id: "categories",
                    type: "categories",
                    subtitle: "Categories",
                    value: { categoryType: CATEGORY_TYPES.CUSTOM_CONTENTS },
                    placeholder: i18n.t(`common::label::Select category`),
                    essential: false,
                },
                { id: "attributions", type: "attributions", subtitle: "Attributions", essential: false },
                { id: "tags", type: "tags", subtitle: "Tags", essential: false },
            ],
        },
        {
            attributions: fields?.map((el) => ({
                isCustomField: true,
                id: el.id,
                subtitle: el.name,
                description: el.description,
                type: el.fieldType.dataType.detailType,
                options: getCustomMetadataOptions(el),
            })),
        },
    ];
};

export const getSearchParamsVocabulary = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter Vocabulary name`, `Enter Vocabulary name`),
                },
                {
                    id: "languageCode",
                    type: "select",
                    subtitle: "Language",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::Select language`, `Select language`),
                },
                {
                    id: "status",
                    type: "select",
                    subtitle: "Status",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::Select status`),
                },
                {
                    id: "creator",
                    type: "users",
                    subtitle: "Created",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                { id: "created", type: "date", subtitle: "Created At", essential: false },
                {
                    id: "updater",
                    type: "users",
                    subtitle: "Updated",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`),
                },
                { id: "updated", type: "date", subtitle: "Updated At", essential: false },
            ],
        },
    ];
};

export const getSearchParamsMetadataExports = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`, `Enter name`),
                },
                {
                    id: "metadataExportStatus",
                    type: "select",
                    subtitle: "Status",
                    multiple: false,
                    essential: false,
                    placeholder: i18n.t(`common::label::Select status`),
                },
                {
                    id: "requestedAt",
                    type: "date",
                    subtitle: "Requested At",
                    multiple: false,
                    essential: false,
                },
            ],
        },
    ];
};

export const getSearchParamsAuditLogs = (domain, domainKeys) => {
    const defaultKeys = ["ResourceId"];
    const targetKeys = ["ResourceId", "ThreadResourceId"];
    const searchKeys = domain ? domainKeys?.find((el) => el.domain === domain)?.searchKeys : defaultKeys;
    const fields = searchKeys
        ?.filter((key) => targetKeys.includes(key))
        ?.map((key) => ({
            id: key,
            subtitle: key,
            placeholder: i18n.t(`common::label::Enter ${key}`),
            type: "text",
        }));
    return [
        {
            attributions: [
                {
                    id: "domain",
                    subtitle: "Domain",
                    type: "select",
                    placeholder: i18n.t(`common::label::Select domain`),
                    multiple: false,
                },
            ],
        },
        {
            customAttributions: fields,
            attributions: [
                {
                    id: "requested",
                    subtitle: "Event occurrence date and time",
                    type: "dateTimeRange",
                },
                {
                    id: "action",
                    subtitle: "Action",
                    placeholder: i18n.t(`common::label::Select action`),
                    type: "select",
                    multiple: false,
                },
                {
                    id: "requestedById",
                    subtitle: "User",
                    type: "users",
                    placeholder: i18n.t(`common::label::Select user`),
                },
                {
                    id: "project",
                    subtitle: "Project",
                    type: "projects",
                    placeholder: i18n.t(`common::label::Select projects`, `Select projects`),
                },
            ],
        },
    ];
};

export const getSearchParamsRoleManagement = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`, `Enter name`),
                },
            ],
        },
    ];
};

export const getSearchParamsContentSchema = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    essential: false,
                    placeholder: i18n.t(`common::label::Enter name`, `Enter name`),
                },
            ],
        },
    ];
};

export const getSearchParamsMySharedAssets = () => {
    return [
        {
            attributions: [
                {
                    id: "projectIds",
                    subtitle: "Project",
                    type: "objectSelect",
                    multiple: true,
                    placeholder: i18n.t(`common::label::Select projects`, `Select projects`),
                    essential: true,
                },
            ],
        },
    ];
};

export const getSearchParamsAdminUsers = () => {
    return [
        {
            attributions: [
                {
                    id: "project",
                    subtitle: "Project",
                    type: "single_project",
                    placeholder: i18n.t(`common::label::Select projects`, `Select projects`),
                    essential: true,
                },
            ],
        },
    ];
};

export const getSearchParamsProjectUsers = () => {
    return [
        {
            attributions: [
                {
                    id: "adminPermission",
                    subtitle: "Admin permission",
                    type: "objectSelect",
                    multiple: false,
                    essential: true,
                    placeholder: i18n.t(`common::label::Select admin`),
                },
            ],
        },
    ];
};

export const getSearchParamsProjectAssignableGroups = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    multiple: false,
                    essential: false,
                },
            ],
        },
    ];
};

export const getSearchParamsProjectAssignableUsers = () => {
    return [
        {
            attributions: [
                {
                    id: "name",
                    subtitle: "Name",
                    type: "text",
                    multiple: false,
                    essential: false,
                },
            ],
        },
    ];
};
